<template>
  <div class="jobs" v-show="selected_week_index >= 0">
    <div class="row">
      <JobHeader
        class="col-12"
        @tab_selected="show_tab"
        @select_date_clicked="_toggle_show_pick_date"
        :selected="tab"
      />
    </div>
    <div class="row">
      <ViewCombinedSchedule v-show="tab == -1" class="col-12" />
    </div>
    <div class="row">
      <ManageSchedule
        v-show="tab >= 0"
        :schedule_index="schedule_index"
        class="col-12"
        ref="manage_schedule"
      />
      <ScheduleWeekPicker
        class="col-12"
        v-if="showMoveRoundModal"
        :schedule_index="schedule_index"
        :week_index="week_index"
        @schedule_and_week_selected="_move_round_to_schedule_selected"
        @close="_close_schedule_selection"
      />
    </div>
    <div class="row">
      <div class="col-12">Status:</div>
    </div>
    <div class="row">
      <div class="col-12">
        Today is: {{ moment().format("dddd, MMMM DD, YYYY") }}
      </div>
    </div>
    <SelectDate v-show="show_pick_date" @close="_toggle_show_pick_date" />
    <DatePickerModal
      v-if="round"
      v-show="showAddRoundChangeModal"
      @close="_close_add_round_change_modal"
      @save="_create_round_change"
      :from_default="from_round_change_date"
      :to_default="to_round_change_date"
      :from_valid_dates="from_round_valid_dates"
      :to_valid_dates="to_round_valid_dates"
      :item="round"
    />
  </div>
</template>

<script>
import moment from "moment";
import JobHeader from "@/components/job/JobHeader.vue";
import ViewCombinedSchedule from "@/components/job/ViewCombinedSchedule.vue";
import ManageSchedule from "@/components/job/ManageSchedule.vue";
import SelectDate from "@/components/job/SelectDate.vue";
import ScheduleWeekPicker from "@/components/job/ScheduleWeekPicker.vue";
import DatePickerModal from "@/components/job/edit/DatePickerModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Jobs",
  data: () => ({
    tab: -1,
    schedule_index: -1,
    week_index: -1,
    show_pick_date: false,
    showMoveRoundModal: false,
    showAddRoundChangeModal: false,
    round: null,
    from_round_change_date: new Date(),
    to_round_change_date: new Date(),
    from_round_valid_dates: { start: new Date(), end: null },
    to_round_valid_dates: { start: new Date(), end: null },
  }),
  computed: {
    ...mapState("schedule", ["schedules", "next_schedule_round_tmp_id", "selected_week_index"]),
    ...mapState("status", ["round_to_move", "round_to_change"]),
  },
  watch: {
    selected_week_index(new_value) {
      this.week_index = new_value;
    },
    round_to_move(new_value) {
      if (new_value != null) {
        this.showMoveRoundModal = true;
        this.week_index = new_value.week_index;
        this.nextTmpScheduleRoundId(),
          (this.round = {
            id: this.next_schedule_round_tmp_id,
            round: new_value.round,
            active: true,
            day_index: new_value.day_index,
            personnels: new_value.personnels,
            round_id: new_value.round_id,
            schedule_id: new_value.schedule_id,
            sequence_order: new_value.sequence_order,
            vehicle: new_value.vehicle,
            vehicle_id: new_value.vehicle_id,
            week_index: new_value.week_index,
          });
        this.clear_move_round();
      }
    },
    round_to_change(new_value) {
      if (new_value != null) {
        var schedule = this.schedules.filter(
          x => x.id === new_value.schedule_id,
        )[0];
        var interval = parseInt(schedule.duration);
        var day = ((new_value.day_index + 1) % 7) + 1;
        this.from_round_valid_dates = {
          start: new Date(schedule.date),
          end: null,
          weekdays: [day],
          weeklyInterval: interval,
        };
        this.to_round_valid_dates = {
          start: new Date(),
          end: null,
          weekdays: [2, 3, 4, 5, 6],
        };
        this.week_index = new_value.week_index;
        this.round = new_value;
        this.showAddRoundChangeModal = true;
        this.clear_add_round_change();
      }
    },
  },
  methods: {
    moment(arg) {
      return moment(arg);
    },
    ...mapActions("schedule", [
      "nextTmpScheduleRoundId",
      "create_round_change",
    ]),
    ...mapActions("status", ["clear_move_round", "clear_add_round_change"]),
    show_tab(index) {
      this.tab = index;
      if (index >= 0) {
        this.schedule_index = index;
      }
    },
    _toggle_show_pick_date() {
      this.show_pick_date = !this.show_pick_date;
    },
    _move_round_to_schedule_selected(data) {
      this.showMoveRoundModal = false;
      this.show_tab(data.schedule);
      this.$refs.manage_schedule.open_round(
        data.schedule,
        data.week,
        this.round,
      );
    },
    _close_schedule_selection() {
      this.showMoveRoundModal = false;
    },
    _close_add_round_change_modal() {
      this.showAddRoundChangeModal = false;
    },
    _create_round_change(data) {
      this.create_round_change({
        round: data.item,
        from: data.from,
        to: data.to,
      });
      this.showAddRoundChangeModal = false;
    },
  },
  components: {
    JobHeader,
    ManageSchedule,
    ViewCombinedSchedule,
    SelectDate,
    ScheduleWeekPicker,
    DatePickerModal,
  },
};
</script>
